var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "sfcContainer",
      staticClass: "sfcContainer",
      class: { showScrollBar: _vm.showScrollBar },
      style: { background: _vm.background },
      on: { mousedown: _vm.onMousedown },
    },
    [
      _vm.showScaleBar
        ? _c("SFCActionBar", {
            attrs: { scale: _vm.scale },
            on: {
              "update:scale": function ($event) {
                _vm.scale = $event
              },
            },
          })
        : _vm._e(),
      _c(
        "div",
        {
          ref: "sfcContent",
          staticClass: "sfcContent",
          class: {
            vertical: _vm.vertical,
            transformOriginCenter: _vm.scale <= 100,
          },
          style: { transform: "scale(" + _vm.scale / 100 + ")" },
        },
        _vm._l(_vm.data, function (node) {
          return _c("SFCNode", {
            key: node.id,
            attrs: { nodeList: _vm.data, data: node },
          })
        }),
        1
      ),
      _vm.showHideDiv ? _c("div") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }